export default __webpack_public_path__ + "static/media/bg-banner-1.8c3eca66.jpg";